import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import {
	AutocompleteInput,
	BulkActionProps,
	BulkDeleteButton,
	DateInput,
	List,
	ListProps,
	ReferenceInput,
	TextInput
} from 'react-admin';
import { TrainingList } from './TrainingList';
import { TrainingDatagrid } from './TrainingDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { Training } from './Training';

export * from './Training';
export * from './TrainingCreate';
export * from './TrainingDatagrid';
export * from './TrainingEdit';
export * from './TrainingList';
export * from './TrainingShow';

const TrainingsBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'featuredImageUrl', header: 'Feature image' },
	{ key: 'name', header: 'Name' },
	{ key: 'order', header: 'Order' },
	{ key: 'description', header: 'Description' },
	{ key: 'category.name', header: 'Category' },
	{ key: 'organization.name', header: 'Organization' }
];

export const TrainingsData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: Training) => entity;

	const trainingsFilter = [
		<TextInput source="name" alwaysOn label="SEARCH"/>,
		<ReferenceInput
			step={1}
			label="CATEGORY"
			source="categoryId" reference="training-categories"
			alwaysOn
		>
			<AutocompleteInput optionText="name"/>
		</ReferenceInput>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('אימונים', exportFields, exportDataMapper)}
				{...props}
				filters={trainingsFilter}
				bulkActionButtons={<TrainingsBulkActionButtons/>}
				title="TRAININGS"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <TrainingList/> : <TrainingDatagrid/>}
			</List>
		</Fragment>
	);
};
